module.exports = __webpack_public_path__ + "img/img-header.d945e69.webp";